// components/CMS/StatisticsCards.js
import React from "react";
import CMSRender from "aldoo-ra/CMS/cms-render";
import Typography from "aldoo-ra/Typography";
import { url } from "aldoo-ra/CMS/url";

// DualIconCard Component
const DualIconCard = ({ icon, icon_2, title }) => {
  return (
    <div className="flex flex-col items-center justify-center mx-auto">
      <div className="flex items-center">
        <img
          src={icon_2}
          alt="Star Rating"
          className="w-[70px] md:w-[98px] aspect-98/20 mr-2"
        />
        <Typography 
          component="h3" 
          variant="h2" 
          className="text-text"
        >
          {title}
        </Typography>
      </div>

      <div className="flex flex-col items-center">
        <img
          src={icon}
          alt="App Store"
          className="w-[120px] md:w-[164px] aspect-164/44 mb-1 text-text"
        />
      </div>
    </div>
  );
};

// StatisticsCards Component
const StatisticsCardsRating = () => {
  return (
    <div className="flex w-full md:max-w-[600px] lg:max-w-w2_xl lg:h-[122px] items-center justify-center rounded-[50px] mx-auto">
      <div 
        className="grid grid-cols-2 lg:grid-cols-4 max-w-[500px] md:w-[600px] md:max-w-[600px] lg:max-w-[1062px] lg:w-full md:h-[260px] lg:h-[130px] gap-y-[50px] md:gap-y-0 pl-[30px] md:pl-0"
        //style={{ gridTemplateRows: "130px 130px" }}
      >
        <CMSRender
          contentType="ProductStatisticsBanner"
          match={{ "content.id": "statistics_banner_2" }}
          renderItem={(banner) => {
            return (banner?.cards || []).map((card, id) => {
              // Render based on the card's position
              return (
                <div key={id} className="flex flex-row items-start md:items-center justify-center lg:p-0">
                  {/* Card 1: Single Icon Card */}
                  {id === 0 && card.icon && !card.icon_2 && (
                    <img
                      src={card.icon}
                      alt={card.title}
                      className="w-[420px] lg:w-[372px] h-[73px]"
                    />
                  )}

                  {/* Card 2: Text Only Card */}
                  {id === 1 && (
                    <div className="flex flex-col w-full items-center justify-center space-y-2 text-center">
                      <Typography 
                        component="h3" 
                        variant="h2" 
                        className="text-text"
                      >
                        {card.title}
                      </Typography>

                      <Typography variant="body1">
                        {card.info}
                      </Typography>
                    </div>
                  )}

                  {/* Card 3: Dual Icon Card */}
                  {id === 2 && card.icon && card.icon_2 && (
                    <DualIconCard
                      icon={card.icon}
                      icon_2={card.icon_2}
                      title={card.title}
                    />
                  )}

                  {/* Card 4: Text Only Card (with unique content) */}
                  {id === 3 && (
                    <div className="flex flex-col w-full items-center justify-center space-y-2 text-center">
                      <Typography 
                        component="h3" 
                        variant="h2" 
                        className="text-text"
                      >
                        {card.title}
                      </Typography>

                      <Typography variant="body1">
                        {card.info}
                      </Typography>
                    </div>
                  )}
                </div>
              );
            });
          }}
        />
      </div>
    </div>
  );
};

export default StatisticsCardsRating;
